import {
  PageEvent,
  TrackEvent,
  Payload,
  IdentifyEvent,
} from "./types/hightouch";

// While we do not use the SDK the following parameters are expected to be
// visible client side: https://hightouch.com/docs/events/sdks/browser#installation
const HIGHTOUCH_URL = "https://us-east-1.hightouch-events.com";
const WRITE_KEY =
  "ec051fd03e80c658d485ebe1ec24e4a48d3b2017b47e2c6a4b0800e6f684eb6d";

function sendEvent(url: string, payload: Payload) {
  return fetch(`${HIGHTOUCH_URL}${url}`, {
    method: "POST",
    body: JSON.stringify({
      ...payload,
      messageId: crypto.randomUUID(),
      sentAt: new Date().toISOString(),
    }),
    headers: {
      Authorization: `Basic ${btoa(WRITE_KEY)}`,
      "Content-Type": "application/json",
    },
  });
}

function track(data: TrackEvent) {
  const props: Payload = {
    type: "track",
    ...data,
  };

  return sendEvent("/v1/track", props);
}

function identify(data: IdentifyEvent) {
  const props: Payload = {
    type: "identify",
    ...data,
  };

  return sendEvent("/v1/identify", props);
}

function page(data: PageEvent) {
  const props: Payload = {
    type: "page",
    ...data,
  };

  return sendEvent("/v1/page", props);
}

export default {
  identify,
  page,
  track,
};
